import type { ReactNode } from "react";
import { Box, type BoxProps } from "@mantine/core";

type EcosystemExploreCardFooterProps = {
  children: ReactNode;
} & Pick<BoxProps, "px" | "pb" | "pt" | "mt">;

/** Shared bottom footer for expert/corridor explore cards — keeps CTA buttons aligned. */
export default function EcosystemExploreCardFooter({
  children,
  px = "md",
  pb = "md",
  pt,
  mt,
}: EcosystemExploreCardFooterProps) {
  return (
    <Box px={px} pb={pb} pt={pt} mt={mt} style={{ flexShrink: 0 }}>
      {children}
    </Box>
  );
}
